import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ROUTES, SECTIONS } from "./state/constants";

/**
 * Cutover helper (plan Part 10). Registered — in Phase 9 only — on the five old wizard
 * routes so every existing link lands on the builder without editing any caller:
 *
 *   /admin/events/create                 → /admin/events/builder{search}
 *   /admin/events/:id/create             → /admin/events/builder/:id{search}
 *   /admin/events/create/:id/step-2      → /admin/events/builder/:id?section=invitee
 *   /admin/events/create/:id/step-3      → /admin/events/builder/:id?section=availability
 *   /admin/events/create/:id/step-4      → /admin/events/builder/:id?section=invitee
 *
 * `?type=` (and any other query) is preserved; `section` is only added for the step routes.
 */
export const resolveBuilderUrl = (pathname, search, id) => {
  const params = new URLSearchParams(search || "");
  const stepMatch = /\/step-(\d)$/.exec(pathname || "");
  if (stepMatch) {
    const step = stepMatch[1];
    const section =
      step === "3" ? SECTIONS.AVAILABILITY : SECTIONS.INVITEE; // step-2 and step-4 → invitee
    params.set("section", section);
  }
  const qs = params.toString();
  const base = id ? `${ROUTES.BUILDER}/${id}` : ROUTES.BUILDER;
  return qs ? `${base}?${qs}` : base;
};

const RedirectToBuilder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  useEffect(() => {
    navigate(resolveBuilderUrl(location.pathname, location.search, id), { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default RedirectToBuilder;
